module.exports = __webpack_public_path__ + "static/media/32-iveco-mercedes.712e8267.jpg";